import { render, staticRenderFns } from "./QuickPanelManual.vue?vue&type=template&id=c08ecdfa&"
import script from "./QuickPanelManual.vue?vue&type=script&lang=js&"
export * from "./QuickPanelManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports